<script>

    import { toast } from 'bulma-toast'

    import TilService from '../$services/til.service'

    import { modalStore, eventStore } from '../stores'

    import File from '../$components/file.svelte'
    import Form from '../$components/form.svelte'
    import Button from '../$components/button.svelte'
    import ButtonSave from '../$components/button.save.svelte'
    import SelectOwners from '../$components/select.owners.svelte'

    let loading = false
    let data = {
        ownerId: '60edc374e9091e00151699c0'
    }

    async function uploadCoverageTil() {

        loading = true
        const resp = await TilService.uploadCoverageTil(data)
        loading = false

        if(!resp.success)
            return toast({message: resp.error.message, type: 'is-danger'})
    
        toast({message: `Cobertura actualizada`, type: 'is-success'})
        
        eventStore.set('coverage_updated')
        modalStore.set(null)
    }
    
</script>

<Form on:submit={uploadCoverageTil} {loading} >
    <div class="columns">
        <div class="column">
            <SelectOwners bind:ownerId={data.ownerId} label="Propietario" />
        </div>
    </div>
    <div class="columns">
        <div class="column">
            <File bind:file={data.coverage} />
        </div>
    </div>
    <div class="is-flex is-justify-content-flex-end is-align-items-center">
        <Button on:click={modalStore.close} text="Cancelar" icon="ban" />
        <ButtonSave icon="save" text="Subir cobertura" />
    </div>
</Form>